/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_License_VInputs */

const en_home_spec_license_v = /** @type {(inputs: Home_Spec_License_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT or Apache-2.0`)
};

/**
* | output |
* | --- |
* | "MIT or Apache-2.0" |
*
* @param {Home_Spec_License_VInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_license_v = /** @type {((inputs?: Home_Spec_License_VInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_License_VInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_license_v(inputs)
});
export { home_spec_license_v as "home.spec.license_v" }